import { takeLeading, put, select, call, getContext } from "redux-saga/effects";
import { TResult } from "../../../../sg-core";
import {
    IRequestDelegateObservation,
    createSuccessFetchDelegateObservationAction,
    createFailureFetchDelegateObservationAction,
    requestDelegateObservation,
    createSuccessFetchObservationAction,
} from "../actions/observationActions";

import IObservation from "../../interfaces/IObservation";
import { IObservationService, IDelegateObservationOptions } from "../../services/observationService";
import { selectLoggedInUserId } from "../../auth/store/authSelectors";
import { createRequestFetchObservationPageAction } from "../actions/observationListActions";

const makeFetchDelegateObservationSaga = () =>
    function* saga(action: IRequestDelegateObservation) {
        const { user: reciever, observationGuid } = action.payload

        //@ts-ignore
        const loggedInUserId = yield select(selectLoggedInUserId);
        const observationService: IObservationService = yield getContext("observation");

        try {

            const delegateOptions: IDelegateObservationOptions = { reciever: reciever.id, loggedInUser: loggedInUserId, observationGuid };

            const delegateResult: TResult<{ observation: IObservation }> = yield call(observationService.delegateObservation, delegateOptions);
            if (!delegateResult.isSuccess) {
                yield put(createFailureFetchDelegateObservationAction(delegateResult.isFailure ? delegateResult.error : new Error("Failed to delegate observation")));
                return
            }

            yield put(createRequestFetchObservationPageAction());
            yield put(createSuccessFetchDelegateObservationAction(delegateResult.value.observation.id));
            yield put(createSuccessFetchObservationAction(delegateResult.value.observation));

        } catch (e) {
            console.log(e)
            yield put(createFailureFetchDelegateObservationAction(e as Error));
        }


    };

export default function create() {
    return takeLeading(
        requestDelegateObservation,
        makeFetchDelegateObservationSaga(),
    );
}